import {PluginService} from "../../services/PluginService";
import {FileDataService} from "../../services/FileDataService";
import {EditModel} from "./EditModel";
import {Plugin} from "../../entities/Plugin";

export class EditPluginModel extends EditModel<Plugin> {
    b64String:string;
    static $inject = ['$q','PluginService','FileDataService'];
    constructor($q:ng.IQService, service:PluginService, public fileDataService:FileDataService){
        super($q, service, Plugin);
    }
    loadData(entityId?: number): ng.IPromise<boolean> {
        this.b64String = null;
        return super.loadData(entityId);
    }
    saveData():ng.IPromise<boolean> {
        if (this.entity.name == null) {
            return this.$q.reject("Enter a name")
        }
        else if (this.entityId == null && (this.b64String == null || this.b64String == "")) {
            return this.$q.reject("Upload a plugin before saving.")
        }
        else {
            var newUploadPromise: ng.IPromise<number> = this.b64String != null && this.b64String != "" ?
                this.fileDataService.insert(this.b64String) : this.$q.when<number>(this.entity.fileDataID);
            return newUploadPromise.then((fileDataID) => {
                this.entity.fileDataID = fileDataID;
                //finally save entity
                return super.saveData();
            });
        }
    }
  }
